import { Component, computed, inject, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiAgencyUsersFormComponent } from '@program-suite/ui-agency-users-form';
import { ButtonComponent } from '@program-suite/ui';
import { AgencyStore, InviteAgencyUsersREQ, LookupStore, LookupViewModel } from '@program-suite/data-common';
import { ModalLayoutComponent } from '@program-suite/ui';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AddAgentViewModel } from '@program-suite/data-common';

@Component({
  selector: 'lib-add-users-modal',
  imports: [
    CommonModule, 
    UiAgencyUsersFormComponent, 
    ButtonComponent,
    ModalLayoutComponent
  ],
  templateUrl: './add-users-modal.component.html',
  styleUrl: './add-users-modal.component.scss',
})
export class AddUsersModalComponent {
  data = inject(MAT_DIALOG_DATA);
  dialogRef = inject(MatDialogRef<AddUsersModalComponent>);
  lookupStore = inject(LookupStore);
  agencyStore = inject(AgencyStore);
  agencyId = input<number | null>(null);
  roles = computed(() => this.lookupStore.agencyRoles() ?? []);

  constructor(
  ) {
    this.lookupStore.loadLookup('agencyRoles');
  }

  submitUsersForm(data: { users: AddAgentViewModel[]; agencyId: number }) {
    
    const invite : InviteAgencyUsersREQ = {
      agencyId: data.agencyId,
      agents: data.users
    }
    this.dialogRef.close(invite);
  }
}

